import $ from 'jquery';

export const init = ($target, scroll) => {
	const _target = $target[0];
	const modalOpens = [].slice.call(_target.querySelectorAll('.js-modal-open'));
	const modal = _target.querySelector('.js-modal'),
		modalWrap = _target.querySelector('.js-modal-wrap'),
		modalBox = _target.querySelector('.js-modal-box'),
		closeBtnFake = _target.querySelector('.js-modal-close-span'),
		closeBtn = _target.querySelector('.js-modal-close'),
		content = _target.querySelector('.js-modal-content');
	var target = null,
		ajaxType = null;
	if (!modal) return;

	closeBtnFake.addEventListener('click', modalCloseFake, true);
	closeBtn.addEventListener('click', modalClose, true);

	function modalCloseFake(e) {
		closeBtn.click();
	}

	function modalClose(e) {
		if (e.target !== modalWrap && e.target !== closeBtn) {
			return;
		}

		window.dispatchEvent(new Event('resizeGlider'));

		e.preventDefault();
		const _this = this;
		_target.body.classList.remove('modal-open');

		_target.body.style.paddingRight = '';
		_target.body.style.position = '';
		_target.body.style.width = '';
		_target.body.style.top = '';
		const scrollPosition = localStorage.getItem('scroller');
		window.scrollTo(0, scrollPosition);

		modalBox.classList.remove('modal__box--transport');
		modalBox.classList.remove('modal__box--static-img');
		modalBox.removeAttribute('aria-modal');
		modalBox.removeAttribute('role');
		modalBox.setAttribute('aria-hidden', true);
		dataLayerClose(target);
		target = null;
	}

	function modalOpen(e) {
		e.preventDefault();
		const _this = this;

		target = _this.dataset.modalTarget;
		if (target) {
			modalWrap.addEventListener('click', modalClose, true);
			const parent = _this.closest('.js-modal');
			const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
			if (_this.dataset.modalTransport === 'true') {
				modalBox.classList.add('modal__box--transport');
			}
			document.body.classList.add('modal-open');

			modalBox.removeAttribute('aria-hidden');
			modalBox.setAttribute('aria-modal', true);
			modalBox.setAttribute('role', 'dialog');
			modalBox.scrollTop = 0;

			const scrollPosition = window.pageYOffset;
			localStorage.setItem('scroller', scrollPosition);
			document.body.style.paddingRight = scrollbarWidth + 'px';
			document.body.style.position = 'fixed';
			document.body.style.width = '100%';
			document.body.style.top = `-${scrollPosition}px`;
			const dataType = _this.dataset.modalType;
			if (dataType == 'json') {
				ajaxType = 'application/json';
				fetch(target, {
					credentials: 'same-origin',
					headers: {
						'Content-Type': ajaxType,
					},
				})
					.then((response) => response.json())
					.then((data) => {
						content.innerHTML = data.modalHtml;
						modalOpens.forEach((item) => {
							item.removeEventListener('click', modalOpen, true);
						});
						closeBtn.removeEventListener('click', modalClose, true);
						modalWrap.removeEventListener('click', modalClose, true);
						document.dispatchEvent(new Event('contentload'));
					});
			} else if (dataType == 'html') {
				ajaxType = 'text/html';
				fetch(target, {
					credentials: 'same-origin',
					headers: {
						'Content-Type': ajaxType,
					},
				})
					.then((response) => response.text())
					.then((data) => {
						content.innerHTML = data;
						modalOpens.forEach((item) => {
							item.removeEventListener('click', modalOpen, true);
						});
						closeBtn.removeEventListener('click', modalClose, true);
						modalWrap.removeEventListener('click', modalClose, true);
						document.dispatchEvent(new Event('contentload'));
					});
				/* 
					Special modal used in wysiwyg. It must be done this way because Froala cannot parse correctly innerHtml with other data types. 
					The target is image source.
				*/
			} else if (dataType == 'static-image') {
				const imageSrc = target;
				modalBox.classList.add('modal__box--static-img');
				content.innerHTML = `<img src=${imageSrc} class="tooltip-img-froala__image" />`;
				modalOpens.forEach((item) => {
					item.removeEventListener('click', modalOpen, true);
				});
				closeBtn.removeEventListener('click', modalClose, true);
				modalWrap.removeEventListener('click', modalClose, true);
				document.dispatchEvent(new Event('contentload'));
			}
			dataLayerOpen(target);
		} else {
			console.error('js-modal data-modal-target is ' + target);
		}
	}
	modalOpens.forEach((item, key) => {
		item.addEventListener('click', modalOpen, true);
	});

	const dataLayerOpen = (target) => {
		if (target) {
			dataLayer.push({
				event: 'modalOpen',
				modalName: target,
			});
		}
	};

	const dataLayerClose = (target) => {
		if (target) {
			dataLayer.push({
				event: 'modalClose',
				modalName: target,
			});
		}
	};
};
